import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { Breadcrumb } from './breadcrumb'

@Component({
  selector: 'ftr-breadcrumbs-dropdown-display',
  templateUrl: 'breadcrumbs-dropdown-display.component.html',
  styleUrls: ['breadcrumbs-display.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BreadcrumbsDropdownDisplayComponent {
  collapsed = input.required<Breadcrumb[]>()
}
